import type { Environment } from "@porsche-customer/slfinrtl-environment"
import type { AxiosInstance } from "axios"
import axios from "axios"
import qs from "query-string"
import { urlMap } from "src/common/getAxiosInstance/urlMap"
import type { AxiosParams } from "./AxiosParams"

const envMap: Record<"K" | "PP" | "P", Environment> = {
	K: "dev",
	P: "prod",
	PP: "preview",
}

export const getAxiosInstance = async (params: AxiosParams): Promise<AxiosInstance> => {
	const { Authorization } = await params.getAuthorizationHeader()
	return axios.create({
		baseURL: (params.environment && urlMap[envMap[params.environment]]) ?? "http://localhost:8090",
		paramsSerializer: {
			serialize: (p) => qs.stringify(p, { arrayFormat: "index" }),
		},
		...params.config,
		headers: {
			...params.config?.headers,
			accept: "application/json",
			Authorization,
			"Content-Type": "application/json",
		},
	})
}
